import { cn } from '@/lib/utils';

interface MobileCountBadgeProps {
  count: number | undefined;
}

const MULTI_DIGIT_THRESHOLD = 10;

// Not the desktop CountBadge: the mobile design keeps zero counts visible in a
// muted tone (desktop hides them). Absent counts render nothing.
export function MobileCountBadge({ count }: MobileCountBadgeProps) {
  if (count === undefined) return null;
  return (
    <span
      className={cn(
        'inline-flex h-6 min-w-6 flex-shrink-0 items-center justify-center rounded-xs font-funkis text-xs font-bold leading-none tabular-nums',
        count === 0 ? 'bg-dinnerplate-white text-grey' : 'bg-brand-yellow text-text-primary',
        count >= MULTI_DIGIT_THRESHOLD && 'px-2',
      )}
    >
      {count}
    </span>
  );
}
